// extracted by mini-css-extract-plugin
export default {"token_amount":"CurrencyQuantity_token_amount__-hnnE","currency_quantity":"CurrencyQuantity_currency_quantity__3PJ53"};